import React, { createContext, useContext, useState, useEffect } from 'react';
import { useUserData } from './UserDataContext';
import { collection, getDocs } from "firebase/firestore";
import { FBDataBase } from '../Firebase/firebase'; // Ensure this is correctly imported
import {doc, updateDoc} from 'firebase/firestore';


const DashboardDataContext = createContext({});

export const useDashData = () => {
  return useContext(DashboardDataContext);
};

export const DashDataProvider = ({ children }) => {
  const { userData } = useUserData();
  const [residentsData, setResidentsData] = useState([]);
  const [residencesData, setResidencesData] = useState([]);

  useEffect(() => {
    const fetchResidents = async () => {
      if (userData?.isAdmin) {  // Ensure user is admin before fetching
        try {
          const querySnapshot = await getDocs(collection(FBDataBase, "users"));
          const usersArray = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
          }));
          console.log('users array', usersArray)
          setResidentsData(usersArray);
        } catch (error) {
          console.error("Error fetching users: ", error);
        }
      }
    };



    fetchResidents();
    
  }, [userData]);

  useEffect(()=>{
    const fetchResidences = async() => {
        try {
          const querySnapshot = await getDocs(collection(FBDataBase, "residences"));
          const residencesArray = querySnapshot.docs.map(doc=>({
            id: doc.id,
            ...doc.data()
          }))
          console.log("residences array ", residencesArray);
          const sortedResidences = [...residencesArray].sort((a, b) => {
            const streetComparison = a.name?.localeCompare(b.name);
            if (streetComparison !== 0) {
                return streetComparison; // If streets are different, sort by name
            }
            return (a.number || 0) - (b.number || 0); // If same street, sort by number
          });

          setResidencesData(sortedResidences)
        } catch(error) {
          console.error("Error fetching residences: ", error)
        }

    }
    fetchResidences()
  },[]);



  const updateResidence = async (id, updatedFields) => {
    try {
      const ref = doc(FBDataBase, 'residences', id);
      await updateDoc(ref, updatedFields);
  
      // Update state locally
      setResidencesData(prev =>
        prev.map(res =>
          res.id === id ? { ...res, ...updatedFields } : res
        )
      );
      console.log(`Residence ${id} updated successfully`);
    } catch (error) {
      console.error('Error updating residence:', error);
      throw error;
    }
  };

  const updateResident = async (id, updatedFields) => {
    try {
      const ref = doc(FBDataBase, 'users', id);
      await updateDoc(ref, updatedFields);
  
      setResidentsData(prev =>
        prev.map(res =>
          res.id === id ? { ...res, ...updatedFields } : res
        )
      );
  
      console.log(`Resident ${id} updated successfully`);
    } catch (error) {
      console.error('Error updating resident:', error);
      throw error;
    }
  };
  
  const toggleAdminStatus = async (id, currentStatus) => {
    try {
      const ref = doc(FBDataBase, 'users', id);
      const newStatus = !currentStatus;
      await updateDoc(ref, { isAdmin: newStatus });
  
      setResidentsData(prev =>
        prev.map(res =>
          res.id === id ? { ...res, isAdmin: newStatus } : res
        )
      );
  
      console.log(`Toggled isAdmin for ${id} to ${newStatus}`);
    } catch (error) {
      console.error('Error toggling admin status:', error);
      throw error;
    }
  };
  
  

  return (
    <DashboardDataContext.Provider value={{ residentsData, residencesData, updateResidence, updateResident, toggleAdminStatus }}>
      {children}
    </DashboardDataContext.Provider>
  );
};
